var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload_",
    "data-name": "Upload ",
    transform: "translate(-140.002 -70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34052",
    "data-name": "Path 34052",
    d: "M152,70a1.333,1.333,0,0,1,.943.391l5.333,5.333a1.333,1.333,0,0,1-1.885,1.885l-3.057-3.057V86a1.333,1.333,0,0,1-2.667,0V74.552l-3.057,3.057a1.333,1.333,0,0,1-1.886-1.885l5.333-5.333A1.333,1.333,0,0,1,152,70ZM141.336,84.667A1.333,1.333,0,0,1,142.669,86a12.658,12.658,0,0,0,.077,2.114,4,4,0,0,0,3.143,3.143,12.661,12.661,0,0,0,2.114.077h8a12.663,12.663,0,0,0,2.114-.077,4,4,0,0,0,3.143-3.143A12.619,12.619,0,0,0,161.336,86,1.333,1.333,0,1,1,164,86v.154a13.339,13.339,0,0,1-.128,2.48,6.666,6.666,0,0,1-5.238,5.238,13.354,13.354,0,0,1-2.479.128h-8.309a13.356,13.356,0,0,1-2.48-.128,6.667,6.667,0,0,1-5.238-5.238,13.36,13.36,0,0,1-.128-2.48V86a1.333,1.333,0,0,1,1.333-1.333Z",
    transform: "translate(0)",
    fill: "#707070",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.0ab215330f016fd1c31a59d227943861.svg";
export { ForwardRef as ReactComponent };